import React from 'react'

// The small monospace label that opens a section, a stat, or the hero. One
// component so every eyebrow on the page is set the same way: mono, uppercase,
// tracked, accent-coloured. Pass `tone="muted"` where the accent would fight
// the content (inside the dark block, captions under figures).
const Eyebrow = ({ children, tone = 'accent', as: Tag = 'p', style = {} }) => (
  <Tag
    style={{
      margin: 0,
      fontFamily: 'var(--brand-fontStack-monospace)',
      fontSize: '12px',
      lineHeight: 1.4,
      fontWeight: 500,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      // Primer Brand's own accent token is green; Civic Lens is blue. The dark
      // blocks override --cl-accent with a lighter step for contrast.
      color: tone === 'accent' ? 'var(--cl-accent, var(--base-color-scale-blue-5))' : 'var(--brand-color-text-muted)',
      ...style,
    }}
  >
    {children}
  </Tag>
)

export default Eyebrow
